import { InventoryItemAddon, InventoryItemApp } from '../item-types';

// Partial properties of a ResellerItem from @vendasta/store (circular dependency)
export class GenericResellerItem {
  appId?: string;
  addonId?: string;
  name?: string;
  icon?: string;
  usesEditions?: boolean;
  editionId?: string;

  constructor(resellerItem?: Partial<GenericResellerItem>) {
    Object.assign(this, resellerItem);
  }
}

export function fromResellerItem(resellerItem: GenericResellerItem): InventoryItemApp | InventoryItemAddon {
  if (resellerItem.addonId) {
    return {
      itemId: resellerItem.addonId ?? '',
      type: 'addon',
      name: resellerItem.name ?? '',
      iconUrl: resellerItem.icon ?? '',
      parentItemId: resellerItem.appId ?? '',
      quantity: 1,
    };
  }

  let edition: InventoryItemApp['edition'] | undefined;
  if (resellerItem.usesEditions && resellerItem.editionId) {
    edition = {
      editionId: resellerItem.editionId,
      name: resellerItem.name ?? '',
    };
  }
  return {
    itemId: resellerItem.appId ?? '',
    type: 'app',
    name: resellerItem.name ?? '',
    iconUrl: resellerItem.icon ?? '',
    edition: edition,
    quantity: 1,
  };
}
